require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-zi-hx-yy.json") })
        }
      }, "path---photos-professional-zi-hx-yy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-zi-hx-yy!./.cache/json/photos-professional-zi-hx-yy.json
// module id = 1222
// module chunks = 231608221292675